import styled from "styled-components";
import { BaseGrid } from "./BaseGrid";
export const FullHeightGrid = styled(BaseGrid) `
  height: 100%;
`;
